import {Component, OnInit} from "@angular/core";
import {AngularFireStorage} from "@angular/fire/storage";
import {map, finalize} from "rxjs/operators";
import {Observable} from "rxjs";

import {ProjectService} from "../_services/";
import * as firebase from "firebase/app"; // Typescript
// import firebase from 'firebase/app'; // JS
import "firebase/functions";
import {environment} from "../../environments/environment";

@Component({
  selector: "app-drive-test",
  templateUrl: "./drive-test.component.html",
  styleUrls: ["./drive-test.component.scss"],
})
export class DriveTestComponent implements OnInit {
  ref: any;
  downloadURL: Observable<string>;
  constructor(
    private afStorage: AngularFireStorage,
    private _project: ProjectService
  ) {}

  ngOnInit() {
    const app = firebase.initializeApp(environment.firebaseConfig);
    app.functions().useFunctionsEmulator("http://localhost:5000");
    this.callCallable();
  }

  // Upload file
  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    const randomId = Math.random().toString(36).substring(2);
    const fileName = `${randomId}-${event.target.files[0].name}`;
    this.ref = this.afStorage.ref(fileName);
    const task = this.afStorage.upload(fileName, event.target.files[0]);
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.downloadURL = this.ref.getDownloadURL();
          this.downloadURL.subscribe((url) => {
            if (url) {
              let data = {
                download_url: url,
                fileName: fileName,
                type: "file",
              };

              this._project.uploadFileToDrive(data).subscribe(
                (res) => {
                  if (res) {
                    console.log(res, "response fromt the server");
                  }
                },
                (err) => {
                  console.error(err, "this is error response");
                }
              );
            }
          });
        })
      )
      .subscribe((url) => {});
  }

  // check cloud function
  async callCallable() {
    var functions = firebase.functions();
    //Callable function 1
    let createFile = firebase
      .functions()
      .httpsCallable("get_project_map_step_fields");
    const result: any = await createFile({
      uid: 14109,
      step_id: "dCiGuPKGqPQCSzTBa7W8",
      project_id: "evKUiNYXoDKYi8vImzcQ",
      step_number: 2,
    });
    // Callable function 2
    //   let createFile = firebase.functions().httpsCallable('submit_schedule_walk_through'); // submit_schedule_walk_through
    //   const result:any = await createFile({"date1": "2023-09-14T18:30:00.000Z","time1": "02:00 AM",
    //     "date2": "2023-09-14T18:30:00.000Z",
    //     "time2": "04:00 AM",
    //     "date3": "2023-09-27T18:30:00.000Z",
    //     "time3": "09:30 AM",
    //     "note": "sdfadfasdf",
    //     "uid": "14109",
    //     "contact_first_name":"Pankaj",
    //     "contact_last_name":"Kumar",
    //     "owner_contact_id":"14109",
    //     "project_id":"Qgyi6VCYFH871whVFmlE",
    //     "project_name": "Test Project 14"
    // });
    // Callable function 3
    // let createFile = firebase.functions().httpsCallable('create_file_mail_notification');
    // const result:any = await createFile({project_map_step_field_id: 'Zy3PlGuCMUSGheaoI8sp', project_id: 'LjBnVz3CNhK0B68sAGWU', gd_folder_id: '1SBQA7OuTCJDowy7uw1BBbXkjWOA9zslb', gd_file_id: '17iEBiQGwcC5K4DHlL8_9G2IvQBP5oZUH', owner_contact_id:'14109',contact_first_name:'Pankaj', contact_last_name:'Contact2', step_number: "2", project_map_step_field_name: "Floor Plan",project_name:"VE Project", contact_id:"wTLrbp89CgUXirmywcPN" });
    // Callable Function 4
    // let createFile = firebase.functions().httpsCallable('request_technical_designer');
    // const result:any = await createFile({project_id: '3QQoyvcYFuZBdK3ePgnR', owner_contact_id: '14109', step_number: '6', step_id: 'LhIlUTywq2V8mVEyd4eW' });
    // Callable Function 5
    // let createFile = firebase.functions().httpsCallable('request_approval_button');
    // const result:any = await createFile({email_recepient_id: 'pm6_request_approval_i_plans', owner_contact_id: '14109', project_id: '7TH4LfgSZLuXoOwvyKQG', field_name: 'Installation Plan' });
    // Callable Function 6
    // let createFile = firebase.functions().httpsCallable('request_delivery_button');
    // const result:any = await createFile({uid: '14109', owner_contact_id: '14109', project_id: '7TH4LfgSZLuXoOwvyKQG', contact_first_name: 'Pankaj', contact_last_name: 'Contact2', step_number: '7' });
    // let editProject = firebase.functions().httpsCallable('edit_project');
    // const result:any = await editProject({accounting_ref: '14109', address: 'Sector 22, Noida', budget: '50', contact_id :'wTLrbp89CgUXirmywcPN',contact_source_id:'15',email:'ajay123@gmajl.com',first_name:"Pankaj",last_name:"Contact4",mobile_phone:"123456785",name:"TestAjayKumar",owner_contact_id:"Vs1HItBZggPR7TvEHFf4VF8zD292",showroom:"131909",status_id:"29",project_id:"m6IDSnHljuazVRliHwf2" });
  }
}
